export const Tillvals = {
  wfik: ["barnsakerhetsbeslag_", "fonsterhallare_1237"],
  wfuk: ["barnsakerhetsbeslag_", "fonsterhallare_1236", "assa_184"],
  wfuks: ["fonsterhallare_1236", "assa_184"],
  wfduk: ["barnsakerhetsbeslag_", "assa_160", "assa_92", "assa_93"],
  wfdik: ["barnsakerhetsbeslag_", "assa_160", "assa_92", "assa_93"],
};
